import styled from '@emotion/styled'
import { Grid } from '@mui/material';
import { mediaQueryMobileLimit } from '../../../../../utils/constants';

export const ServiceItemStyled = {
  Container: styled(Grid) <any>`
    border-radius: 5px;
    width: 100%;
   
  `,
  ContainerContent: styled(Grid) <any>`
    flex-direction: column;
    padding: 20px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      margin-bottom: 0px;
     }
  `,
  Title: styled.p<any>`
    font-family: EncodeSans-Bold;
    font-size: 18px;
    margin-bottom: 12px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 16px;
      margin-bottom: 0;
      text-align: center;
     }
  `,
  Description: styled.p<any>`
    font-family: EncodeSans-Regular;
    font-size: 16px;
    margin-bottom: 20px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
     font-size: 14px;
     margin-bottom: 20px;
     padding: 15px;
     text-align: center;
     }
  `,
  ContainerIcon: styled.div<any>`
    padding: 20px;
    display: flex;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      justify-content: center;
     }
  `,

};
